import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class FormCategoryNamesParser implements Parser {
	parse(schema: Schema.FormCategories) {
		const names = schema.map(({ value }) => `"${value}"`);

		return names.length
			? `export type FormCategoryLabels = ${names.join("|")}`
			: "";
	}
}
